import {Component, OnInit} from '@angular/core';
import {Select, Store} from '@ngxs/store';
import {Observable} from 'rxjs';
import {PanelOutputGroup} from '../../../core/models/panel-output-group';
import {PanelOutputLockingStatus} from '../../../core/models/panel-output-locking-status';
import {PanelOutput} from '../../../core/models/panel-output.interface';
import {ClosePanelOutputGroup, OpenMomentOutputGroup} from '../../../core/store/panel-outputs/panel-outputs.actions';
import {PanelOutputsStateSelectors} from '../../../core/store/panel-outputs/panel-outputs.selectors';
import {SharedState} from '../../../core/store/shared/shared.state';

@Component({
  selector: 'app-selected-group',
  templateUrl: './selected-group.component.html',
  styleUrls: ['./selected-group.component.scss']
})
export class SelectedGroupComponent implements OnInit {
  @Select(SharedState.isDarkTheme) isDarkTheme$: Observable<boolean>;
  @Select(PanelOutputsStateSelectors.selectedGroup) selectedGroup$: Observable<PanelOutputGroup>;
  @Select(PanelOutputsStateSelectors.selectedGroupOutputs) selectedOutputs$: Observable<PanelOutput[]>;

  groupLockingStatus = PanelOutputLockingStatus;

  constructor(private store: Store) {
  }

  ngOnInit() {
  }

  closeOutputs(group: PanelOutputGroup) {
    this.store.dispatch(new ClosePanelOutputGroup(group));
  }

  openOutputs(group: PanelOutputGroup) {
    this.store.dispatch(new OpenMomentOutputGroup(group));
  }
}
